__turbopack_context__.v({
  "placeholder": "K0LowG_placeholder",
  "section": "K0LowG_section",
  "section-cols-2": "K0LowG_section-cols-2",
  "section-cols-3": "K0LowG_section-cols-3",
  "section-masonry": "K0LowG_section-masonry",
  "section-pbd-3xl": "K0LowG_section-pbd-3xl",
  "section-pbd-3xs": "K0LowG_section-pbd-3xs",
  "section-pbd-l": "K0LowG_section-pbd-l",
  "section-pbd-m": "K0LowG_section-pbd-m",
  "section-pbd-none": "K0LowG_section-pbd-none",
  "section-pbd-s": "K0LowG_section-pbd-s",
  "section-pbd-xl": "K0LowG_section-pbd-xl",
  "section-pbd-xs": "K0LowG_section-pbd-xs",
  "section-pbd-xxl": "K0LowG_section-pbd-xxl",
  "section-pbd-xxs": "K0LowG_section-pbd-xxs",
  "section-pbm-3xl": "K0LowG_section-pbm-3xl",
  "section-pbm-3xs": "K0LowG_section-pbm-3xs",
  "section-pbm-l": "K0LowG_section-pbm-l",
  "section-pbm-m": "K0LowG_section-pbm-m",
  "section-pbm-none": "K0LowG_section-pbm-none",
  "section-pbm-s": "K0LowG_section-pbm-s",
  "section-pbm-xl": "K0LowG_section-pbm-xl",
  "section-pbm-xs": "K0LowG_section-pbm-xs",
  "section-pbm-xxl": "K0LowG_section-pbm-xxl",
  "section-pbm-xxs": "K0LowG_section-pbm-xxs",
  "section-ptd-3xl": "K0LowG_section-ptd-3xl",
  "section-ptd-3xs": "K0LowG_section-ptd-3xs",
  "section-ptd-l": "K0LowG_section-ptd-l",
  "section-ptd-m": "K0LowG_section-ptd-m",
  "section-ptd-none": "K0LowG_section-ptd-none",
  "section-ptd-s": "K0LowG_section-ptd-s",
  "section-ptd-xl": "K0LowG_section-ptd-xl",
  "section-ptd-xs": "K0LowG_section-ptd-xs",
  "section-ptd-xxl": "K0LowG_section-ptd-xxl",
  "section-ptd-xxs": "K0LowG_section-ptd-xxs",
  "section-ptm-3xl": "K0LowG_section-ptm-3xl",
  "section-ptm-3xs": "K0LowG_section-ptm-3xs",
  "section-ptm-l": "K0LowG_section-ptm-l",
  "section-ptm-m": "K0LowG_section-ptm-m",
  "section-ptm-none": "K0LowG_section-ptm-none",
  "section-ptm-s": "K0LowG_section-ptm-s",
  "section-ptm-xl": "K0LowG_section-ptm-xl",
  "section-ptm-xs": "K0LowG_section-ptm-xs",
  "section-ptm-xxl": "K0LowG_section-ptm-xxl",
  "section-ptm-xxs": "K0LowG_section-ptm-xxs",
  "text-intro": "K0LowG_text-intro",
});
